var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCaptcha24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_captcha24x24",
    transform: "translate(-3 -2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3 2.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46071",
    "data-name": "Path 46071",
    d: "M15.92,8.62l-.943-1.5.559-1.681a.51.51,0,0,0-.227-.6l-1.526-.886L13.5,2.2a.508.508,0,0,0-.478-.427l-1.759-.068L10.209.29A.5.5,0,0,0,9.587.136L8,.9,6.409.135A.5.5,0,0,0,5.787.29L4.733,1.709l-1.76.07a.506.506,0,0,0-.478.426L2.214,3.955.689,4.841a.51.51,0,0,0-.228.6L1.02,7.123.078,8.62a.511.511,0,0,0,.077.639l1.271,1.227-.143,1.766a.508.508,0,0,0,.363.53l1.689.49.689,1.632a.5.5,0,0,0,.565.3l1.726-.358,1.364,1.124a.5.5,0,0,0,.639,0L9.68,14.848l1.726.358a.5.5,0,0,0,.565-.3l.689-1.632,1.689-.49a.508.508,0,0,0,.363-.53l-.135-1.767,1.271-1.227a.511.511,0,0,0,.073-.639ZM11.643,6.176,8.115,11.5a.693.693,0,0,1-.546.332.886.886,0,0,1-.579-.263L4.4,8.92a.472.472,0,0,1,0-.656l.64-.656a.449.449,0,0,1,.64,0L7.364,9.335l2.784-4.2a.447.447,0,0,1,.629-.123l.75.519A.472.472,0,0,1,11.643,6.176Z",
    transform: "translate(0 -.086)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCaptcha24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_captcha24x24.e6710a6bf9037e59b0419205e4824473.svg";